import {
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
} from "@chakra-ui/react";
import DrawerFormFooter from "components/Shared/DrawerForm/DrawerFormFooter";
import Form from "./Form";
import { useCreateOrderingPlatform } from "./useCreateOrderingPlatform";

const FORM_ID = "create-orderingPlatform-form";

type Props = {
  isAdmin?: boolean;
  onCloseEdit: () => void;
  onCompleted: (id: UUID) => void;
};

export default function CreateOrderingPlatform({
  isAdmin,
  onCloseEdit,
  onCompleted,
}: Props) {
  const { handleValidSubmit, isSaving } = useCreateOrderingPlatform(isAdmin);

  return (
    <DrawerContent bg="cardBackground">
      <DrawerCloseButton />
      <DrawerHeader>Create Customer</DrawerHeader>
      <DrawerBody>
        <Form
          formId={FORM_ID}
          isAdmin={isAdmin}
          onValidSubmit={(formData, context) =>
            handleValidSubmit(formData, context).then((result) => {
              const newId =
                result?.data?.createOrderingPlatform?.orderingPlatform?.id;
              if (newId) onCompleted(newId);
            })
          }
        />
      </DrawerBody>
      <DrawerFormFooter
        onClose={onCloseEdit}
        formId={FORM_ID}
        submitButtonProps={{
          isLoading: isSaving,
        }}
      />
    </DrawerContent>
  );
}
